export default __webpack_public_path__ + "slices/main/assets/public/media/camper-underlines/underline--short-white.398503c951c005808b10ca1a6f7ef754.svg";